<div class="dialog" *ngIf="showWidget" [@showWidget]>
  <div class="dialog-background" (click)="onClose(widgetCloseTarget.BACKGROUND)"></div>
  <div class="dialog-content">
    <div class="interview-widget-close">
      <a (click)="onClose(widgetCloseTarget.CLOSE_ICON)"> <span class="icon-i-close-circle"></span> </a>
    </div>
    <div class="interview-widget">
      <div class="interview-widget-content">
        <ng-container *ngIf="widgetStep === widgetSteps.REGISTRATION">
          <h2 class="ui-headline">{{ 'interviewWidget.participate.title' | translate }}</h2>
          <p>{{ 'interviewWidget.participate.p1' | translate }}</p>
          <p>{{ 'interviewWidget.participate.p2' | translate }}</p>
          <div class="ui-button-group">
            <button class="ui-button" (click)="onParticipate()">{{ 'interviewWidget.participate.cta' | translate }}</button>
            <button class="ui-button-text" (click)="onClose(widgetCloseTarget.CLOSE_THANKS)">
              {{ 'interviewWidget.participate.close' | translate }}
            </button>
          </div>
          <p class="interview-widget-disclaimer">{{ 'interviewWidget.participate.disclaimer' | translate }}</p>
        </ng-container>

        <ng-container *ngIf="widgetStep === widgetSteps.THANKS">
          <div class="interview-widget-thanks">
            <div>
              <h2 class="ui-headline">{{ 'interviewWidget.thanks.title' | translate }}</h2>
              <p>{{ 'interviewWidget.thanks.p' | translate }}</p>
            </div>
            <div>
              <button class="ui-button fit-width" (click)="onClose(widgetCloseTarget.CLOSE_BTN)">
                {{ 'interviewWidget.thanks.close' | translate }}
              </button>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="interview-widget-img">
        <img src="assets/images/interview-widget-img.png" alt="Interview Widget Img" />
      </div>
    </div>
  </div>
</div>
